module.exports = __webpack_public_path__ + "static/media/robust.6771c35d.svg";